import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import GridItem from "components/Grid/GridItem";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import { removeUnderscores } from "utils/Utils";
import { previewDealSharetableColumns } from "assets/properties/properties";
const DealShareDetails = ({
  partnerDealCode,
  partnerDealData,
  closeModal
}) => {
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('')
  const [redirectURL, setRedirectURL] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [selectedTableData, setSelectedTableData] = useState([]);
  useEffect(()=>{
    if(partnerDealCode && partnerDealData?.length > 0){
      const filteredData = partnerDealData?.filter((item) => item.code === partnerDealCode)
      if(filteredData?.length){
        parseIndicatorData(filteredData?.[0]?.partnerDealShare);
      }
    }
  },[partnerDealData,partnerDealCode]);
  const parseIndicatorData = (data) => {
      let reportData = [];
      data &&
        data.forEach((role, index) => {
          let row = {
            name: role.name,
            type: removeUnderscores(role?.type),
            code: role?.partnerDealCode,
            percentage: role.percentage,
            disbursal: role?.isDisbursal === true ? "Yes" : "No",
          };
          reportData.push(row);
        });
      setSelectedTableData(reportData);
    };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const handleCancelUser = () => {
    closeModal();
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label="Deal Share Details"
            button1=" Cancel"
            button1click={handleCancelUser}
          />
        </Grid>
      </Grid>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={previewDealSharetableColumns}
          rows={selectedTableData}
        />
      </GridItem>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </div>
  );
};
DealShareDetails.propTypes = {
  classes: PropTypes.object,
};
export default DealShareDetails;